module.exports = __webpack_public_path__ + "static/media/MyTicketsUpIcon.03b3a15a.svg";